import { Link } from "react-router-dom";

const JobCard = ({
  job,
  normalizeCity,
  formatRupiah,
  handleStatus,
  showDetailButton = true,
}) => {
  const handleText = (text) => (text ? text.slice(0, 100) + "..." : "");

  const timeAgo = (dateString) => {
    const now = new Date();
    const past = new Date(dateString);

    const diffMs = now - past;
    const diffMinutes = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) return `${diffDays} hari yang lalu`;
    if (diffHours > 0) return `${diffHours} jam yang lalu`;
    if (diffMinutes > 0) return `${diffMinutes} menit yang lalu`;
    return "baru saja";
  };

  return (
    <Link
      to={`/detail/${job._id}`}
      className="w-full max-w-xs bg-white border border-gray-200 rounded-xl shadow-sm
             hover:border-indigo-600 hover:bg-indigo-50 transition
             flex flex-col h-full">
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-sm font-semibold text-gray-900">{job.title}</h3>
            <p className="text-xs text-gray-500">
              {job.company_name} · {normalizeCity(job.company_city)}
              <span
                className={`ml-2 inline-flex items-center px-2 py-0.5 text-xs rounded ${
                  handleStatus(job.job_status).className
                }`}>
                {handleStatus(job.job_status).label}
              </span>
            </p>
          </div>

          <img
            src={job.company_image_url}
            alt={job.company_name}
            className="w-10 h-10 object-contain"
          />
        </div>

        <p className="text-sm font-bold text-gray-900">
          {formatRupiah(job.salary_min)}{" "}
          <span className="text-gray-400 font-light">-</span>{" "}
          {formatRupiah(job.salary_max)}
        </p>

        <p className="text-sm text-gray-600 line-clamp-2">
          {handleText(job.job_description)}
        </p>
      </div>

      <div className="mt-auto p-4 pt-0 space-y-3">
        <div className="flex items-center justify-between text-xs text-gray-500">
          <span className="px-2 py-0.5 border border-gray-200 rounded">
            {job.job_type}
          </span>
          <span>{timeAgo(job.createdAt)}</span>
        </div>

        {showDetailButton && (
          <button
            type="button"
            className="w-full py-2 text-sm font-semibold text-white bg-black
                   rounded-lg hover:bg-gray-900 transition">
            Detail
          </button>
        )}
      </div>
    </Link>
  );
};

export default JobCard;
